<template>
    <div>
      <bankChannelTab>
        <template v-slot="{channelType}">
          <base-list-management
              v-if="channelType === bankChannelType"
              ref="baseListManagement"
              :configData.sync="getConfigData"
              @component-mounted="getTransactionTypeList()"
          >
              <div slot="custom-export" v-if="showExportBtn">
                <el-button
                  style="position: relative; right: 8px"
                  @click="showExportDialog">导出数据</el-button>
              </div>
            </base-list-management>
        </template>
      </bankChannelTab>
      <exportDialog ref="exportDialog" />
    </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { queryTransactionList } from '@/api/domain/finance'
import bankChannelTab from '@/pages/finance/bankChannelTab'
import { operateMaxShowLength } from '@/store/dict/config'
import moment from 'moment'
import { mapGetters } from 'vuex'
import config from './config'
import exportDialog from './exportDialog'

export default {
  components: { bankChannelTab, exportDialog },
  data() {
    const { configData } = config.call(this)
    return {
      configData,
      transactionTypeList: [],
    }
  },
  created() {
    this.configData.formData.formProps.model.channelType = this.bankChannelType
  },
  methods: {
    async getTransactionTypeList() {
      const { code, data } = await queryTransactionList({
        channelType: this.bankChannelType,
      })
      if (code === 1) {
        this.transactionTypeList = data
        // 因为baselist在v-if中，所以要防止组件销毁后数据请求才返回的情况，加上空指针判断
        this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'transactionType', data })
      }
    },
    showExportDialog() {
      const { model } = this.$refs.baseListManagement.formData.formProps
      const transactionTypeObj =
        this.transactionTypeList.find((item) => item.type === model.transactionType)
      // 判断是否允许导出
      // 交易时间不能为空，且交易时间选择时间段不能超过6个月，才允许导出
      // 否则不允许导出
      if (!model.transactionTime || model.transactionTime.length === 0) {
        this.$message.error('交易时间不能为空')
        return
      }
      const durations = moment.duration({ from: model.transactionTime[0], to: model.transactionTime[1] })
      if (durations.years() * 12 + durations.months() >= 6) {
        this.$message.error('交易时间时长不能超过6个月')
        return
      }
      this.$refs.exportDialog.showDialog({
        ...model,
        transactionTypeName: transactionTypeObj?.name,
        bankChannelName: this.bankChannelName,
      })
    },
  },
  computed: {
    ...mapGetters(['bankChannelType', 'bankChannelName']),
    showExportBtn() {
      return this.checkBankChannelPermission('trade_detail_export', 'trade_detail_export_wangshang', this.bankChannelType)
    },
    getConfigData() {
      const { columns } = this.configData.tableData
      if (this.bankChannelType === 8 && this.judgePermission('downloadReceipt')) {
        columns.push({
          name: 'operate',
          type: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          render: ({ row }) => {
            const h = this.$createElement
            const elLink = h('el-link', {
              props: {
                underline: false,
                type: 'primary',
                disabled: !row.receiptOssKey,
              },
              on: {
                click: () => {
                  const link = document.createElement('a')
                  link.style.display = 'none'
                  link.href = row.receiptOssKey
                  link.setAttribute('download', row.fileName)
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                },
              },
            }, '下载回单')
            const elTooltip = h('el-tooltip', {
              props: {
                content: '由于银行限制，仅交易付款方可下载回单',
              },
            }, [elLink])
            return row.receiptOssKey ? elLink : elTooltip
          },
        })
      } else {
        const index = columns.findIndex((item) => item.name === 'operate')
        if (index !== -1) columns.splice(index, 1)
      }
      return this.configData
    },
  },
  watch: {
    bankChannelType: {
      handler(val) {
        this.configData.formData.formProps.model.channelType = val
      },
    },
  },
}
</script>
<style scoped>
.el-link.el-link--primary.is-disabled {
  color: #a0cfff; /** TODO：由el主题色控制，现在由于有2套CSS相互覆盖导致要强行指定 */
}
</style>
